export default __webpack_public_path__ + "static/mladapobuda_img1-2d979e42c019065088d3477bcc28c628.png";